import type { PageAccessRequirement } from '~/types/permissions'
import { useAuthStore } from '~/stores/authStore'

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore()
  const { can } = usePermissions()
  const accessRequirement = to.meta.requiredPermissions as PageAccessRequirement | PageAccessRequirement[] | undefined

  if (!accessRequirement) {
    return
  }

  const requirements = Array.isArray(accessRequirement) ? accessRequirement : [accessRequirement]

  if (!authStore.isAuthenticated) {
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }

  if (!authStore.activeLicence) {
    return
  }

  if (!authStore.permissionsLoaded) {
    try {
      await authStore.loadPermissions()
    } catch (error) {
      console.error('[Permission Middleware] Failed to load permissions:', error)
      if (to.path === '/') {
        return
      }
      return navigateTo({
        path: '/',
        query: { error: 'permissions_not_loaded' }
      })
    }
  }

  if (!authStore.siteReachLoaded) {
    try {
      await authStore.loadSiteReach()
    } catch (error) {
      console.error('[Permission Middleware] Failed to load site reach:', error)
      authStore.setActiveSite(undefined)
    }
  }

  if (!requirements.some((requirement) => can(requirement.container, requirement.action).value)) {
    console.warn('[Permission Middleware] Access denied:', {
      requirements: requirements.map(({ container, action }) => ({ container, action })),
      path: to.path
    })

    const redirectTo = requirements.find((requirement) => requirement.redirectTo)?.redirectTo
    if (redirectTo) {
      return navigateTo(redirectTo)
    }

    return navigateTo('/403')
  }
})
